
import React from 'react';
import { Phone, Menu } from 'lucide-react';

const Benifits = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <h1 className="text-3xl md:text-2xl lg:text-3xl font-bold text-[#2c2b2b] mb-6 leading-tight">
            Work Freely, Anytime, Anywhere, With Our<br />
            Industry-Best Mobile CRM
          </h1>
          <p className="text-md text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Manage your business from anywhere, anytime, by staying connected beyond traditional working hours. Unlock
            productivity and streamline operations, whether you're in the field, at home, or anywhere in between.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Present, Everywhere! */}
          <div className="rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 flex flex-col h-80">
            <div className="h-60 relative" style={{ backgroundColor: '#1E90FF' }}></div>
            <div className="p-3 bg-white flex-1 flex flex-col justify-center">
              <h3 className="text-xl font-bold text-gray-900">Present, Everywhere!</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Best-in-class Mobile CRM to keep your contacts and leads up to date!
              </p>
            </div>
          </div>

          {/* Streamlined Tracking */}
          <div className="rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 flex flex-col h-80">
            <div className="h-60 relative" style={{ backgroundColor: '#FF6B47' }}></div>
            <div className="p-3 bg-white flex-1 flex flex-col justify-center">
              <h3 className="text-xl font-bold text-gray-900">Streamlined Tracking</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Track team progress, use data insights on-the-go with cloud computing.
              </p>
            </div>
          </div>

          {/* Boost Productivity */}
          <div className="rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 flex flex-col h-80">
            <div className="h-60 relative" style={{ backgroundColor: '#FFA500' }}></div>
            <div className="p-3 bg-white flex-1 flex flex-col justify-center">
              <h3 className="text-xl font-bold text-gray-900">Boost Productivity</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Catch field sales reps on the move with real-time collaboration tools.
              </p>
            </div>
          </div>

          {/* Proactive Monitoring */}
          <div className="rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 flex flex-col h-80">
            <div className="h-60 relative" style={{ backgroundColor: '#8A2BE2' }}></div>
            <div className="p-3 bg-white flex-1 flex flex-col justify-center">
              <h3 className="text-xl font-bold text-gray-900">Proactive Monitoring</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Oversee agent activities, their location history and scheduled meetings.
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Benifits;